import {
  FormSubmitArgs,
  FormViewConfig,
  FormViewService,
  FormViewServiceProvider,
  vsServiceName as FormViewServiceName,
  vsProviderName as FormViewServiceProviderName,
} from "../../../../records/forms/formView";
import { RecordDataSource } from "../../../../records/grids";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../../records/views/recordGridView";
import fieldHelpers from "../../../../ui-formly/fieldHelpers";
import { vsLookupManagementServiceProviderName as LookupManagementServiceProviderName } from "../../../shared/lookups";
import {
  LookupManagementConfig,
  LookupManagementServiceProvider,
} from "../../../../records/lookup/lookupManagement";
import { MachineDenomination } from "../../../shared/models/machineConfiguration";

export const vsObjectName = "machineDenomination";

const url = "/api/machines/MachineDenomination";

export function machineDenominationLookupConfig(
  lookupManagementServiceProvider: LookupManagementServiceProvider,
  formViewServiceProvider: FormViewServiceProvider,
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  configureLookupManagement(lookupManagementServiceProvider);
  configureForm(formViewServiceProvider);
  recordGridViewServiceProvider.addGridConfiguration(
    vsObjectName,
    getGridConfig
  );
}
machineDenominationLookupConfig.$inject = [
  LookupManagementServiceProviderName,
  FormViewServiceProviderName,
  RecordGridViewServiceProviderName,
];

function configureForm(formViewServiceProvider: FormViewServiceProvider) {
  formViewServiceProvider.addFormViewConfig(vsObjectName, [
    FormViewServiceName,
    (formViewService: FormViewService): FormViewConfig => {
      return {
        fields: [
          fieldHelpers.simpleStringField({
            key: "Name",
            name: "Name",
            label: "Denomination",
            required: true,
          }),
          fieldHelpers.simpleCurrencyField({
            key: "Value",
            name: "Value",
            label: "Value",
            required: true,
            step: 0.01,
          }),
          fieldHelpers.simpleBoolField({
            key: "Disabled",
            name: "Disabled",
            label: "Disabled?",
            defaultValue: false,
          }),
        ],
        name: vsObjectName,
        submitForm: (args: FormSubmitArgs) => {
          const model = <MachineDenomination>args.model;
          return formViewService.saveForm({
            formObject: model,
            formViewController: args.formViewController,
            url: url,
          });
        },
        title: (model: MachineDenomination) =>
          model.Id ? "Edit Denomination" : "Create Denomination",
      };
    },
  ]);
}

function configureLookupManagement(
  lookupManagementServiceProvider: LookupManagementServiceProvider
) {
  lookupManagementServiceProvider.addLookup(vsObjectName, {
    displayName: "Denomination",
    config: [
      ServerUtilityName,
      (serverUtility: ServerUtility): LookupManagementConfig => {
        return {
          fetchFormModel: (id: number) =>
            serverUtility.querySingle({
              url,
              query: { Id: id },
            }),
          baseUrl: url,
        };
      },
    ],
  });
}

function getGridConfig(
  serverUtility: ServerUtility,
  columnDefinitionService: ColumnDefinitionService
): GridConfiguration {
  return {
    columns: [
      columnDefinitionService.getStringColDef({
        field: "Name",
        header: "Denomination",
      }),
      columnDefinitionService.getNumberColDef({
        field: "Value",
        header: "Value",
      }),
      columnDefinitionService.getBooleanColDef({
        field: "Disabled",
      }),
    ],
    gridDataSource: new RecordDataSource(serverUtility, url),
    defaultSort: "Name",
    namePlural: "Denominations",
    nameSingular: "Denomination",
    showAddButton: true,
    showAddButtonPermission: "machineLookupModify",
    showSelectButtons: false,
  };
}
getGridConfig.$inject = [ServerUtilityName, ColumnDefinitionServiceName];
